import { render, staticRenderFns } from "./customer_user.vue?vue&type=template&id=0b93e14e&scoped=true"
import script from "./customer_user.vue?vue&type=script&lang=js"
export * from "./customer_user.vue?vue&type=script&lang=js"
import style0 from "./customer_user.vue?vue&type=style&index=0&id=0b93e14e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b93e14e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b93e14e')) {
      api.createRecord('0b93e14e', component.options)
    } else {
      api.reload('0b93e14e', component.options)
    }
    module.hot.accept("./customer_user.vue?vue&type=template&id=0b93e14e&scoped=true", function () {
      api.rerender('0b93e14e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/customer_information/components/customer_user/customer_user.vue"
export default component.exports